
import { BLUE, CARBON_GRAY, DARK_GRAY, GREEN, LIGHT_GRAY, LIGHT_YELLOW, LOW_BLUE, LOW_GRAY, MEDIUM_BLUE, MEDIUM_RED, OPAQUE_BLUE, OPAQUE_GREEN, OPAQUE_LIGHT_BLUE, OPAQUE_LIGHT_YELLOW, OPAQUE_MEDIUM_BLUE, OPAQUE_MEDIUM_RED, OPAQUE_ORANGE, OPAQUE_PINK, OPAQUE_RED, ORANGE, PINK, RED, SILVER } from "../config";
import { getRiskColorByNameProps } from "./getRiskColorByName";

const valuesSelected = {
  RED,
  MEDIUM_RED,
  ORANGE,
  GREEN,
  LOW_GRAY,
  SILVER,
  CARBON_GRAY,
  PINK,
  BLUE,
  LOW_BLUE,
  MEDIUM_BLUE,
  LIGHT_YELLOW,
};
const valuesNotSelected = {
  RED: OPAQUE_RED,
  MEDIUM_RED: OPAQUE_MEDIUM_RED,
  ORANGE: OPAQUE_ORANGE,
  GREEN: OPAQUE_GREEN,
  LOW_GRAY: LIGHT_GRAY,
  PINK: OPAQUE_PINK,
  BLUE: OPAQUE_BLUE,
  LOW_BLUE: OPAQUE_LIGHT_BLUE,
  MEDIUM_BLUE: OPAQUE_MEDIUM_BLUE,
  LIGHT_YELLOW: OPAQUE_LIGHT_YELLOW,
  SILVER: LIGHT_GRAY,
  CARBON_GRAY: DARK_GRAY,
};

export const getRiskColorByNameAndSelect = (
  isSelect?: boolean,
  color?: getRiskColorByNameProps["color"]
): string | undefined => {
  return isSelect
    ? valuesSelected[color as keyof typeof valuesSelected]
    : valuesNotSelected[color as keyof typeof valuesNotSelected];
};
